import React from 'react';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import PropTypes from 'prop-types';
import DepartedModal from '../departedModal';
import PhaseTask from './phase_task';

export class Departed extends PhaseTask {
  onClick = () => {
    const { phase, task } = this.props;
    if (!phase || !task) return;

    const isInstallation = phase.type === 'Installation';

    if (task.status === 'complete') {
      this.toggleStatus();
    } else if (isInstallation) {
      this.completeTask();
    } else if (this.shouldShowModal()) {
      this.setState({ modalActive: true });
    } else {
      this.completeTask();
    }
  }

  isIhqWorkroom = () => {
    const { phase } = this.props;
    return phase && phase.workroom && (phase.workroom.ihq === true || phase.workroom.ihq === 'true');
  }

  isInstallation = () => {
    const { phase } = this.props;
    return phase && phase.type === 'Installation';
  }

  shouldShowModal = () => {
    const { phase } = this.props;
    if (!phase || !phase.type) return false;

    if (phase.type === 'Installation') {
      return false;
    }
    const isAssessment = phase.type === 'Assessment';
    const isIhq = this.isIhqWorkroom();

    // For Assessments: show modal only if IHQ is enabled (to show disposition)
    // For Installations: always show modal (to show excess materials)
    return (isAssessment && isIhq) || this.isInstallation();
  }

  renderChildren = () => {
    const { phase } = this.props;
    if (!phase || !phase.type) return null;

    if (phase.type === 'Installation') {
      return null;
    }
    if (!this.shouldShowModal()) {
      return null;
    }
    return (
      <DepartedModal
        phase={this.props.phase}
        task={this.props.task}
        active={this.state.modalActive}
        completeTask={this.completeTask}
        onClose={this.handleClose}
      />
    );
  }
}

Departed.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const departed = connect(() => ({}), { updatePhaseTask, clearValidationErrors })(Departed);
export const departed_from_appointment = departed;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/departed.jsx